module.exports = __webpack_public_path__ + "assets/img/app-icon.8de48049.png";